import { render, staticRenderFns } from "./UploadImageModal.vue?vue&type=template&id=70e608fe&scoped=true&"
import script from "./UploadImageModal.vue?vue&type=script&lang=js&"
export * from "./UploadImageModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageModal.vue?vue&type=style&index=0&id=70e608fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e608fe",
  null
  
)

export default component.exports